import { render, staticRenderFns } from "./KlaimHadiah.vue?vue&type=template&id=99461266&scoped=true&"
import script from "./KlaimHadiah.vue?vue&type=script&lang=js&"
export * from "./KlaimHadiah.vue?vue&type=script&lang=js&"
import style0 from "./KlaimHadiah.vue?vue&type=style&index=0&id=99461266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99461266",
  null
  
)

export default component.exports